import cn from 'classnames';
import type React from 'react';
import { useRef } from 'react';
import ReactDOM from 'react-dom';
import { usePopper } from 'react-popper';
import { useOutsideClick } from './model';
import * as st from './styles.module.scss';

interface ItemProps extends React.HTMLAttributes<HTMLDivElement> {
  isActive?: boolean;
  children?: React.ReactNode;
  className?: string;
}

export const MenuItem: React.FC<ItemProps> = ({ isActive, children, className, ...props }) => {
  return (
    <div className={cn(st.item, className, isActive && st.active)} {...props}>
      {children}
    </div>
  );
};

interface MenuProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'id'> {
  referenceEl: Element | null;
  popperEl: HTMLElement | null;
  setPopperEl: React.Dispatch<React.SetStateAction<HTMLElement | null>>;
  onAfterClose?: () => void;
  offset?: [number, number];
  dropdownClasses?: string;
  className?: string;
  children?: React.ReactNode;
  id?: number | string;
}

export const MenuDropdown: React.FC<MenuProps> = ({
  referenceEl,
  popperEl,
  setPopperEl,
  onAfterClose,
  offset = [0, 8],
  dropdownClasses,
  className,
  children,
  id,
  style,
}) => {
  const refPopperEl = useRef(null);
  const { styles, attributes } = usePopper(referenceEl, popperEl, {
    placement: 'bottom-end',
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: offset,
        },
      },
    ],
  });

  const onClose = () => {
    popperEl?.setAttribute('data-show', 'false');
    referenceEl?.setAttribute('data-show', 'false');
    if (onAfterClose) onAfterClose();
  };

  useOutsideClick([refPopperEl], onClose);

  const buttonMenu = document.querySelector(`#button-${id}`);

  return (
    <>
      {buttonMenu &&
        ReactDOM.createPortal(
          <div
            ref={setPopperEl}
            style={style ? style : styles.popper}
            className={cn(
              st.dropdown,
              dropdownClasses,
              className,
              popperEl === null && st.disabled
            )}
            {...attributes.popper}
          >
            <div
              ref={refPopperEl}
              className={cn(st.innerWrapper, popperEl === null && st.disabled)}
            >
              {children}
            </div>
          </div>,
          buttonMenu
        )}
    </>
  );
};
